import { setCssVar } from "@shared/util/css";
import { ThemeBackgroundColors } from "@shared/util/accountTheme";

export const applyThemeBackgroundColors = (colors: ThemeBackgroundColors) => {
  setCssVar('--color-designer-themebg-50', colors['50'])
  setCssVar('--color-designer-themebg-100', colors['100'])
  setCssVar('--color-designer-themebg-200', colors['200'])
  setCssVar('--color-designer-themebg-300', colors['300'])
  setCssVar('--color-designer-themebg-400', colors['400'])
  setCssVar('--color-designer-themebg-500', colors['500'])
  setCssVar('--color-designer-themebg-600', colors['600'])
  setCssVar('--color-designer-themebg-700', colors['700'])
  setCssVar('--color-designer-themebg-800', colors['800'])
  setCssVar('--color-designer-themebg-900', colors['900'])
  setCssVar('--color-designer-themebg-950', colors['950'])
}
